/* KOSMA TEX — Showroom visit booking logic */
(function () {
  'use strict';
  var form = document.getElementById('kvbForm');
  if (!form) return;

  var dateInput = document.getElementById('kvb-date');
  var dateHint = document.getElementById('kvbDateHint');
  var errBox = document.getElementById('kvbError');
  var submitBtn = document.getElementById('kvbSubmit');
  var successBox = document.getElementById('kvbSuccess');
  var successText = document.getElementById('kvbSuccessText');

  /* ---- date bounds: tomorrow .. +90 days ---- */
  function fmtISO(d) {
    return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0');
  }
  var today = new Date();
  var minD = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
  var maxD = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 90);
  dateInput.min = fmtISO(minD);
  dateInput.max = fmtISO(maxD);

  function isWeekend(iso) {
    var d = new Date(iso + 'T12:00:00');
    var day = d.getDay();
    return day === 0 || day === 6;
  }
  function readableDate(iso) {
    var d = new Date(iso + 'T12:00:00');
    return d.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  }
  dateInput.addEventListener('change', function () {
    if (!dateInput.value) return;
    if (isWeekend(dateInput.value)) {
      dateInput.value = '';
      dateHint.textContent = 'We\u2019re open Mon\u2013Fri \u2014 please pick a weekday.';
      dateHint.classList.add('is-warn');
    } else {
      dateHint.textContent = 'Mon\u2013Fri \u00B7 9AM\u20136PM PT';
      dateHint.classList.remove('is-warn');
    }
  });

  function showError(msg) {
    errBox.textContent = msg;
    errBox.hidden = false;
    errBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errBox.hidden = true;

    var name = form.querySelector('#kvb-name').value.trim();
    var email = form.querySelector('#kvb-email').value.trim();
    var date = dateInput.value;
    var timeEl = form.querySelector('input[name="contact[Visit Time]"]:checked');

    if (!name) return showError('Please enter your name.');
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return showError('Please enter a valid email address.');
    if (!date) return showError('Please pick a preferred date (Mon\u2013Fri).');
    if (isWeekend(date)) return showError('We\u2019re open Mon\u2013Fri \u2014 please pick a weekday.');
    if (!timeEl) return showError('Please pick a preferred time.');

    var fd = new FormData(form);
    fd.set('contact[Visit Date]', readableDate(date));

    submitBtn.disabled = true;
    submitBtn.textContent = 'Sending\u2026';

    fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function (res) {
        if (!res.ok) throw new Error('request failed');
        var visitors = form.querySelector('#kvb-visitors').value;
        successText.innerHTML = 'Thanks, ' + escapeHtml(name.split(' ')[0]) +
          ' \u2014 we\u2019ve got your request for <strong>' + escapeHtml(readableDate(date)) +
          '</strong> at <strong>' + escapeHtml(timeEl.value) + '</strong> (' + escapeHtml(visitors) + ').';
        form.hidden = true;
        successBox.hidden = false;
        successBox.scrollIntoView({ behavior: 'smooth', block: 'center' });
      })
      .catch(function () {
        submitBtn.disabled = false;
        submitBtn.textContent = 'Request Visit';
        showError('Something went wrong sending your request.');
      });
  });

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
})();
